import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../services/supabaseClient";

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      const {
        data: { session },
        error,
      } = await supabase.auth.getSession();
      if (error) {
        console.error("Error during auth callback:", error);
        navigate("/auth/auth-code-error");
      } else if (session) {
        // User is authenticated, navigate to home page
        navigate("/");
      } else {
        // No session, navigate to login page
        navigate("/auth");
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return <div>Processing authentication...</div>;
};

export default AuthCallback;
